import type { CalendarGridColDef, CalendarGridRowData } from '../../CalendarGrid.model';

export type Value = NonNullable<CalendarGridRowData['attributes']>['hasCornerstoneInvestors'];

const cornerstoneColDef: CalendarGridColDef<Value> = {
  field: 'attributes.hasCornerstoneInvestors',
  headerName: 'Cornerstone ⓘ',
  headerTooltip: 'Cornerstone Investors (Y/N)',
  width: 140,
  type: 'boolean',
};

export default cornerstoneColDef;
